<script lang="ts">
    import { get } from 'svelte/store';
    import { scale } from 'svelte/transition';
    import { availableChips } from '@root/src/store/chips';
    import { getStringLength } from '@root/src/utils/global';
    import { kFormatter } from '@root/src/utils/ui';
    import { afterUpdate } from 'svelte';

    let className = '';
    export { className as class };
    export let value: number | string = 0;
    export let index: number = 0;
    export let disabled: boolean = false;

    const chipColors = [
        '#9e9c9c',
        '#9e9c9c',
        '#d03e10',
        '#2660c3',
        '#59a61c',
        '#323232',
        '#962ac1',
        '#dea528',
        '#dc87c9'
    ];

    let color1 = '#9e9c9c';

    const getColorChip = (value: number) => {
        const numValue = Number(value);

        const chipLimit = get(availableChips);
        for (let i = 0; i < chipLimit.length; i++) {
            if (numValue < chipLimit[i]) {
                color1 = chipColors[i];
                return;
            }
        }
        color1 = chipColors[chipColors.length - 1];
    };

    let parentElement: HTMLButtonElement;
    let childrenElement;

    const updateFontSize = () => {
        const strLength =
            getStringLength(childrenElement.innerText) === 1 ? 2 : getStringLength(childrenElement.innerText);
        childrenElement.style.fontSize = `${parentElement.clientWidth / strLength + 3}px`;
    };

    afterUpdate(() => {
        updateFontSize();
    });

    $: {
        getColorChip(Number(value));
    }
</script>

{#key value}
    <button
        bind:this={parentElement}
        class="btn-base group relative flex items-center justify-center rounded-full font-bold hover:cursor-pointer {className}"
        on:click
        in:scale={{ start: 1.5 }}
        {disabled}
    >
        <svg width="100%" height="100%" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="24" fill="white" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24 48.0337C37.2686 48.0337 48 37.3023 48 24.0337C48 10.7651 37.2686 0.0336914 24 0.0336914C10.7314 0.0336914 0 10.7651 0 24.0337C0 37.3023 10.7314 48.0337 24 48.0337ZM24 42C33.9514 42 42 33.9514 42 24C42 14.0486 33.9514 6 24 6C14.0486 6 6 14.0486 6 24C6 33.9514 14.0486 42 24 42Z"
                fill={color1}
            />
            <path
                d="M24 0C21.6536 0 19.4036 0.232762 17.25 0.698279L17.8929 3.23276C17.9893 3.75 18.8893 4.5 19.8536 4.5H28.1464C29.1107 4.5 30.0107 3.75 30.1393 3.23276L30.75 0.698279C28.5964 0.232762 26.3464 0 24 0Z"
                fill="white"
            />
            <path
                d="M3.1314 12.0424C2.15555 13.7577 1.44907 15.5384 0.979797 17.3334L3.82374 18.0329C4.39199 18.1623 5.52949 17.8659 5.93779 17.1841L9.46509 11.0559C9.87203 10.3477 9.46676 9.36421 9.00694 9.04426L6.67702 7.41967C5.32843 8.78413 4.10725 10.327 3.1314 12.0424Z"
                fill="white"
            />
            <path
                d="M3.12662 35.9185C4.08774 37.6401 5.29565 39.1917 6.63092 40.5925L8.97466 38.9902C9.43878 38.6483 9.85246 37.6696 9.4516 36.9589L5.97534 30.834C5.57448 30.1232 4.43956 29.8173 3.86865 29.9679L1.01883 30.6418C1.47272 32.4386 2.16391 34.2232 3.12662 35.9185Z"
                fill="white"
            />
            <path
                d="M24 48C26.3464 48 28.5964 47.7414 30.75 47.3017L30.1393 44.7672C30.0107 44.25 29.1107 43.5 28.1464 43.5H19.8536C18.8893 43.5 17.9893 44.25 17.8929 44.7672L17.25 47.3017C19.4036 47.7414 21.6536 48 24 48Z"
                fill="white"
            />
            <path
                d="M44.8597 35.9504C45.8787 34.2682 46.5682 32.4954 47.0497 30.7056L44.2062 29.9894C43.6368 29.8303 42.4957 30.1192 42.0836 30.824L38.5105 36.8964C38.1279 37.5997 38.4979 38.5859 38.9575 38.9346L41.2803 40.5716C42.668 39.1895 43.8713 37.6575 44.8597 35.9504Z"
                fill="white"
            />
            <path
                d="M44.8628 12.0353C43.8799 10.3231 42.6813 8.78549 41.2967 7.42389L38.9688 9.05587C38.5094 9.37728 38.1363 10.3635 38.5167 11.0689L42.0694 17.186C42.4806 17.8665 43.6207 18.1592 44.1893 18.0281L47.0351 17.3195C46.5592 15.526 45.8753 13.749 44.8628 12.0353Z"
                fill="white"
            />
            <path
                d="M24 6C33.9209 6 42 14.0791 42 24C42 33.9209 33.9209 42 24 42C14.0791 42 6 33.9209 6 24C6 14.0791 14.0791 6 24 6ZM24 6.92308C14.5878 6.92308 6.92308 14.5878 6.92308 24C6.92308 33.4122 14.5878 41.0769 24 41.0769C33.4122 41.0769 41.0769 33.4122 41.0769 24C41.0769 14.5878 33.4122 6.92308 24 6.92308Z"
                fill="white"
                fill-opacity="0.3"
            />
            <path
                opacity="0.8"
                d="M41 24C41 33.3991 33.3991 41 24 41C14.6009 41 7 33.3991 7 24C7 14.6009 14.6009 7 24 7C33.3991 7 41 14.6009 41 24Z"
                fill="white"
                stroke="#CBCBCB"
                stroke-width="2"
            />
        </svg>
        <div class="child-chip cstm-position-center text-2xl font-bold" bind:this={childrenElement}>
            {kFormatter(value)}
        </div>
    </button>
{/key}
